import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';
import { get } from 'lodash-es';
import { CommonModule } from '@angular/common';

class InheritStyleDirective {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    ngAfterViewChecked() {
        const element = get(this.elementRef, 'nativeElement', null);
        if (!element) {
            console.error('Could not find elementRef.nativeElement.');
            return;
        }
        if (this.level === 0) {
            console.error('Element already has its own _ngcontent-* attribute, please check the package ReadMe for more info.');
            return;
        }
        this.ngContentRef = get(element, 'attributes[0].name', null);
        const nodeList = get(element, 'childNodes', []);
        this.assignNgContentRef(nodeList, 0);
    }
    assignNgContentRef(nodeList, level) {
        if (!nodeList || level === this.level) {
            return;
        }
        nodeList.forEach((node) => {
            if (get(node, 'nodeType', 0) === Node.ELEMENT_NODE) {
                this.renderer.setAttribute(node, this.ngContentRef, '');
                if (get(node, 'childNodes', [])) {
                    this.assignNgContentRef(node.childNodes, level + 1);
                }
            }
        });
    }
}
InheritStyleDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InheritStyleDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
InheritStyleDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: InheritStyleDirective, selector: "[uprInheritStyle]", inputs: { level: "level" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InheritStyleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uprInheritStyle]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { level: [{
                type: Input
            }] } });

class InheritStyleModule {
}
InheritStyleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InheritStyleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
InheritStyleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InheritStyleModule, declarations: [InheritStyleDirective], imports: [CommonModule], exports: [InheritStyleDirective] });
InheritStyleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InheritStyleModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InheritStyleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [InheritStyleDirective],
                    imports: [CommonModule],
                    exports: [InheritStyleDirective]
                }]
        }] });

export { InheritStyleDirective, InheritStyleModule };
